// extracted by mini-css-extract-plugin
export var phone = "_51-0";
export var phoneDragging = "_51-1";